import http from 'hub-http/clients/apiClient';
const root = 'rollouts-app';
const featureGroupsRoot = `${root}/v2/product/all-feature-groups`;
const rolloutTypesRoot = `${root}/v2/rollout/all-rollout-types`;
export const TranslationAPI = {
  getFeatureGroups: () => http.get(`${featureGroupsRoot}`),
  getRolloutTypes: () => http.get(`${rolloutTypesRoot}`)
};